import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import {Button, Menu} from 'antd';
import {Menu as MenuIcon} from '@styled-icons/boxicons-regular/Menu';
import Config from '../../../data.json';
import * as AppActions from '../../AppActions';
import TopContent from './TopContent';
import {RoutesSpec} from './routes-spec';

const F = AppActions.F;

export default function SiteNavBar(props) {
  const [user] = useOutlet('user');
  const [locale, setLocale] = useOutlet('locale');
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.innerWidth < 1040;
  const lang = locale.lang;

  const [mobileNavVisible, setMobileNavVisible] = React.useState(false);

  return (
    <Wrapper>
      <TopContent />
      <div className="main-container">
        <Main mobile={mobile} lang={lang} innerWidth={dimension.innerWidth}>
          <div
            className="logo"
            onClick={() => {
              AppActions.navigate('/');
              setLocale({lang: 'tw'});
            }}>
            {Config.stage === 'stg' ? (
              <div
                style={{
                  borderRadius: 4,
                  backgroundColor: 'red',
                  color: 'white',
                  paddingLeft: 5,
                  paddingRight: 5,
                  fontSize: '0.9rem',
                  zIndex: 1,
                  letterSpacing: 1.2,
                }}>
                測試站
              </div>
            ) : (
              <img
                className="logo-img"
                src="/images/site-logo.png"
                alt="logo"
              />
            )}
          </div>
          <div className="nav-items">
            {RoutesSpec.map((item, index) => {
              return (
                <div
                  key={`root-nav-item-${index}`}
                  className="nav-item"
                  onClick={() => {
                    if (item.key.indexOf('/') > -1) {
                      const path = F(item, 'key');
                      AppActions.navigate(path);
                    }
                  }}>
                  {F(item, 'label')}

                  {item.children.length > 0 && (
                    <div className="submenu">
                      <div className="container">
                        <div className={`left index-${index}`}>
                          <div className="nav-items">
                            {item.children.map((subroute, index) => {
                              return (
                                <div
                                  key={`subroute-nav-item-${index}`}
                                  className={`nav-item selected-index-${index}`}
                                  onClick={() => {
                                    const path = F(subroute, 'key');
                                    AppActions.navigate(path);
                                  }}>
                                  <div className="gutter-1" />
                                  <div className="gutter-2" />
                                  <div className="text">
                                    {F(subroute, 'label')}
                                  </div>
                                  {subroute.children.length > 0 && (
                                    <div className="menu">
                                      {subroute.children.map((route, index) => (
                                        <div
                                          key={`route-${index}`}
                                          className="menu-item"
                                          onClick={() => {
                                            const path = F(route, 'key');
                                            AppActions.navigate(path);
                                          }}>
                                          {F(route, 'label')}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className={`right selected-${index}`}>
                          <div className="nav-items">
                            <div className="fake-nav-item" />
                            <div className="fake-nav-item" />
                            <div className="fake-nav-item" />
                            <div className="gutter-2" />
                            <div className="gutter-1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="search"></div>
          <div className="rwd-toggle">
            <Button
              className="rwd-toggle-button"
              shape="circle"
              size="small"
              icon={<MenuIcon size={18} color="#ffffff" />}
              onClick={() => setMobileNavVisible(true)}
            />
          </div>
        </Main>
      </div>

      <MobileNavDrawer
        visible={mobile && mobileNavVisible}
        setVisible={setMobileNavVisible}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  z-index: 101;
  width: 100vw;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  & > .main-container {
    background-color: var(--thirdColor);
  }
`;

const Main = styled.div`
  max-width: var(--contentMaxWidth);
  width: 100%;
  margin: 0 auto;

  background-color: var(--thirdColor);
  padding: 0px 20px;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  & > .logo {
    width: 100px;
    display: flex;
    align-items: center;

    & > .logo-img {
      width: 68px;
      cursor: pointer;
    }

    ${(props) => (props.mobile ? `& > .logo-img {width: 55px;}` : ``)};
  }

  & > .nav-items {
    flex: 1;

    display: flex;
    justify-content: center;
    align-items: center;

    & > .nav-item {
      max-width: 200px;
      width: 100%;
      height: 100%;

      color: var(--primaryColor);
      font-size: 1.05rem;
      font-weight: 500;
      text-align: center;
      letter-spacing: 1px;
      cursor: pointer;

      padding: 20px 25px;

      &:hover {
        background-color: #ffffff;

        & > .submenu {
          border-top: 5px solid var(--primaryColor);
          height: ${(props) => (props.lang === 'tw' ? '360px' : '420px')};
        }
      }

      ${(props) =>
        props.mobile
          ? `visibility: hidden; width:0px; height:0px; padding:0px;`
          : `visibility: visible;`};

      & > .submenu {
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        position: absolute;
        top: 62px;
        left: 0px;

        max-width: var(--contentMaxWidth);
        width: 100%;
        margin: 0 auto;

        background-color: #646464;
        height: 0px;
        overflow: hidden;
        transition: 200ms;

        & > .container {
          width: 100%;
          display: flex;
          height: ${(props) => (props.lang === 'tw' ? '360px' : '420px')};
          color: #ffffff;

          & > .left {
            width: 100%;

            &.index-0 {
              max-width: ${(props) =>
                `${320 + (props.innerWidth - 1040) / 2}px`};

              @media screen and (min-width: 1440px) {
                max-width: 520px;
              }
            }

            &.index-1 {
              max-width: ${(props) =>
                `${200 + 320 + (props.innerWidth - 1040) / 2}px`};

              @media screen and (min-width: 1440px) {
                max-width: 720px;
              }
            }

            &.index-2 {
              max-width: ${(props) =>
                `${400 + 320 + (props.innerWidth - 1040) / 2}px`};

              @media screen and (min-width: 1440px) {
                max-width: 920px;
              }
            }

            &.index-3 {
              max-width: ${(props) =>
                `${600 + 320 + (props.innerWidth - 1040) / 2}px`};

              @media screen and (min-width: 1440px) {
                max-width: 1120px;
              }
            }

            & > .nav-items {
              width: 100%;

              & > .nav-item {
                display: flex;
                justify-content: flex-end;
                position: relative;

                & > .text {
                  padding: 8px 22px;
                  max-width: 200px;
                  width: 100%;
                  text-align: left;
                  font-weight: 400;
                  font-size: ${(props) =>
                    props.lang === 'en' ? '0.8rem' : '0.85rem'};
                }

                &:hover {
                  background-color: #323232;
                }

                & > .menu {
                  position: absolute;
                  right: -250px;

                  max-width: 250px;
                  width: 100%;
                  height: 0px;
                  overflow: hidden;

                  & > .menu-item {
                    padding: 8px 22px;
                    width: 100%;
                    text-align: left;
                    color: #969696;
                    font-size: ${(props) =>
                      props.lang === 'en' ? '0.8rem' : '0.85rem'};

                    &:hover {
                      color: #323232;
                    }
                  }
                }
              }

              & > .selected-index-0 {
                ${getSelectedIndexCss(0)}
              }

              & > .selected-index-1 {
                ${getSelectedIndexCss(1)}
              }

              & > .selected-index-2 {
                ${getSelectedIndexCss(2)}
              }

              & > .selected-index-3 {
                ${getSelectedIndexCss(3)}
              }

              & > .selected-index-4 {
                ${getSelectedIndexCss(4)}
              }

              & > .selected-index-5 {
                ${getSelectedIndexCss(5)}
              }

              & > .selected-index-6 {
                ${getSelectedIndexCss(6)}
              }

              & > .selected-index-7 {
                ${getSelectedIndexCss(7)}
              }
            }
          }

          & > .right {
            flex: 1;
            ight: ${(props) => (props.lang === 'tw' ? '360px' : '420px')};
            background-color: #ffffff;

            & > .nav-items {
              display: flex;
              width: 100%;

              & > .fake-nav-item {
                max-width: 200px;
                width: 100%;
                height: 38px;
              }
            }

            &.selected-0 {
            }

            &.selected-1 {
              & > .nav-items > .nav-item:nth-child(3) {
                display: none;
              }
            }

            &.selected-2 {
              & > .nav-items > .nav-item:nth-child(3),
              .nav-item:nth-child(2) {
                display: none;
              }
            }

            &.selected-3 {
              & > .nav-items > .nav-item:nth-child(3),
              .nav-item:nth-child(2),
              .nav-item:nth-child(1) {
                display: none;
              }
            }
          }
        }

        & .gutter-1 {
          width: 120px;
        }

        & .gutter-2 {
          flex: 1;
        }
      }
    }
  }

  & > .search {
    width: 100px;
  }

  & > .rwd-toggle {
    & > .rwd-toggle-button {
      background-color: var(--thirdColor);
      border: none;
    }

    ${(props) => (props.mobile ? `display: block;` : `display: none;`)}
  }

  ${(props) => (props.mobile ? `padding: 10px;` : ``)};
`;

function getSelectedIndexCss(index) {
  let styles = '';

  if (typeof window === 'undefined' || !window.screen) {
    return styles;
  }

  if (window.screen.width > 1040) {
    styles = `&:hover {
      & > .menu {
        top: -${38 * index}px;
        height: 320px;

      }
    }`;
  } else {
    styles = `&:hover {
      & > .menu {
        top: -${34 * index}px;
        height: auto;
        & > .menu-item {
          font-size: 0.5rem;
        }
      }
    }`;
  }

  return styles;
}

function MobileNavDrawer(props) {
  const [user] = useOutlet('user');
  const {visible, setVisible} = props;
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.innerWidth < 1040;

  return (
    <>
      <MobileNavDrawerBackDrop
        mobile={mobile}
        visible={visible}
        onClick={() => setVisible(false)}
      />

      <MobileNavDrawerWrapper mobile={mobile} visible={visible}>
        <h3>功能選單</h3>
        <Menu
          mode="inline"
          theme="dark"
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'var(--thirdColor)',
          }}>
          {RoutesSpec.map((item, index) => {
            if (item.children.length > 0) {
              return (
                <Menu.SubMenu
                  key={`mobile-root-nav-item-${index}`}
                  className="white-color"
                  title={F(item, 'label')}>
                  {item.children.map((subroute, idx) => {
                    if (subroute.children.length > 0) {
                      return (
                        <Menu.SubMenu
                          key={`mobile-subroute-nav-item-${idx}`}
                          className="white-color"
                          title={F(subroute, 'label')}
                          onClick={() => {
                            const path = F(subroute, 'key');
                            AppActions.navigate(path);
                            setVisible(false);
                          }}>
                          {subroute.children.map((route, i) => (
                            <Menu.Item
                              // key={`mobile-nav-item-${i}`}
                              className="white-color"
                              onClick={() => {
                                const path = F(route, 'key');
                                AppActions.navigate(path);
                                setVisible(false);
                              }}>
                              {F(route, 'label')}
                            </Menu.Item>
                          ))}
                        </Menu.SubMenu>
                      );
                    }
                    return (
                      <Menu.Item
                        key={`mobile-subroute-nav-item-${idx}`}
                        className="white-color"
                        onClick={() => {
                          if (subroute.key.indexOf('/') > -1) {
                            const path = F(subroute, 'key');
                            AppActions.navigate(path);
                            setVisible(false);
                          }
                        }}>
                        {F(subroute, 'label')}
                      </Menu.Item>
                    );
                  })}
                </Menu.SubMenu>
              );
            }

            return (
              <Menu.Item
                key={`mobile-root-nav-item-${index}`}
                className="white-color"
                onClick={() => {
                  if (item.key.indexOf('/') > -1) {
                    const path = F(item, 'key');
                    AppActions.navigate(path);
                    setVisible(false);
                  }
                }}>
                {F(item, 'label')}
              </Menu.Item>
            );
          })}
        </Menu>
      </MobileNavDrawerWrapper>
    </>
  );
}

const MobileNavDrawerBackDrop = styled.div`
  width: 100vw;
  height: 100vh;

  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.5);

  ${(props) => (props.visible ? `display: block;` : `display: none;`)};
`;

const MobileNavDrawerWrapper = styled.div`
  width: 256px;
  height: calc(100vh - 32px);
  overflow-y: auto;
  background-color: var(--thirdColor);

  position: absolute;
  top: 32px;
  right: -256px;
  transition: 300ms;

  & > h3 {
    padding: 20px 24px 0px;
    color: #ffffff;
  }

  & .white-color {
    color: #ffffff;
  }

  .ant-menu-sub.ant-menu-inline > .ant-menu-item,
  .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    margin-top: 15px;
    margin-bottom: 8px;
    height: auto !important;
  }

  .ant-menu-title-content {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: pre-wrap !important;
    line-height: 20px;
  }

  ${(props) => (props.visible ? `right: 0px;` : ``)}
`;
